import { Injectable } from '@angular/core';
import { Observable} from 'rxjs';
import {HttpClient, HttpParams} from '@angular/common/http';
import {OfficeAllocationPage} from '../model/office-allocation.model';
import {retry} from 'rxjs/operators';
import {MY_AGENTS_URL} from '../../api-config';
@Injectable({
  providedIn: 'root'
})
export class AgentService {

  constructor(private httpClient: HttpClient) {
  }

  public getAgentsOfCurrentUser(): Observable<OfficeAllocationPage> {
    let params = new HttpParams();
    params = params.set('size', '100');
    return this.httpClient.get<OfficeAllocationPage>(MY_AGENTS_URL, {params}).pipe(retry(5));
  }

}
